import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAllRegions } from "../../HTTP/countries";
import { countries } from "../../global/countriesAndSources";
import "./HomeHub.css";

const normalizeRegions = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export default function RegionsPresentation() {
  const navigate = useNavigate();
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    fetchAllRegions()
      .then((response) => {
        if (isMounted) setRegions(normalizeRegions(response));
      })
      .catch((loadError) => {
        console.error("Erreur lors du chargement des régions", loadError);
        if (isMounted) setError("Les régions n'ont pas pu être chargées.");
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const getCountryName = ({ country_code, country }) =>
    country || countries.find((item) => item.code.toLowerCase() === String(country_code).toLowerCase())?.name || country_code;

  return (
    <main className="home-hub-wrapper">
      <section className="home-hub-igo-card">
        <div className="home-hub-igo-details">
          <p className="home-hub-eyebrow">Découvrir</p>
          <h1>Régions du monde</h1>
          <p>Parcourez les pays regroupés par région et explorez les recherches depuis les pays associés.</p>
        </div>
      </section>

      {loading && <p className="mt-6 text-center">Chargement des régions...</p>}
      {error && <p className="mt-6 text-center text-red-600">{error}</p>}
      {!loading && !error && regions.length === 0 && (
        <p className="mt-6 text-center">Aucune région n'est disponible.</p>
      )}

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {regions.map((region) => (
          <article key={region.id} className="home-hub-igo-card">
            <div className="home-hub-igo-details">
              <h2>{region.name}</h2>
              <p className="home-hub-igo-countries">
                Pays : {(region.countries || []).map(getCountryName).join(", ") || "Aucun pays associé"}
              </p>
              <button
                type="button"
                className="home-hub-action-btn mt-4"
                onClick={() => navigate(`/wd/what-this-country-talk-about?region_id=${encodeURIComponent(region.id)}`)}
              >
                Explorer cette région
              </button>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
